import { getStorage, getDownloadURL, ref } from "@firebase/storage"
import { useState, useRef, useEffect } from "react"
import { firebaseApp } from "../StApp"
import { User } from "../models/Users"
import { ProgStatus } from "../models/utilTypes"
import ApiService from "../services/ApiService"
import AudioPlayer from './ChatAdudioPlayer'

export function VoiceIntro(props: { uid: string }) {
    const [voiceIntrolUrl, setVoiceIntroUrl] = useState<string>()
    const vIntroPlayRecProg = useRef<ProgStatus>('INIT')

    useEffect(() => {
        fetchVIntroUrl()

    }, [])

    function recordPlay() {
        if (vIntroPlayRecProg.current != 'SUCCESS')
            ApiService.recordVIntroPlay({ profileUid: props.uid })
                .then(resp => {
                    vIntroPlayRecProg.current = 'SUCCESS'
                    console.log(resp)
                }).catch(err => {
                    console.error(err)
                })
    }

    async function fetchVIntroUrl() {

        try {
            //console.log(`${chatMsg.chatId}/${chatMsg.lastChatMsg.voice}`)
            const storage = getStorage(firebaseApp)
            const vUrl = await getDownloadURL(ref(storage, `users/${props.uid}/vIntro`))
            setVoiceIntroUrl(vUrl)
        } catch (err) {
            console.error(err)
        }

    }


    return (<AudioPlayer voiceUrl={voiceIntrolUrl} callBack={recordPlay} />);
}